import {scholarshipProgramHighSchoolsConfig} from 'src/views/college-portal/scholarship-program-high-schools';

export const cpModals = [scholarshipProgramHighSchoolsConfig];
